<template>
  <v-dialog :value="value" @click:outside="close" :width="defaultDialogWidth" persistent>
    <v-card>
      <div class="py-4 px-5">
        <h5 class="title">Изменить телефон номер клиента</h5>
      </div>
      <v-card-text>
        <validation-observer v-slot="{handleSubmit}" ref="formObs" tag="div">
          <form @submit.prevent="handleSubmit(savePhones)">
            <v-row dense>
              <v-col cols="12">
                <div class="d-flex">
                  <custom-input-text
                      pattern="###-##-###-##-##"
                      label="Номер телефона"
                      name="Номер телефона"
                      rules="required|phone"
                      vid="phone"
                      class="flex-grow-1"
                      v-model="formData.phone"
                  ></custom-input-text>
                  <btn-with-tooltip
                      v-if="formData.phones.length < 2"
                      @click="formData.phones.length < 2 ? formData.phones.push(null) : ()=>{}"
                      class-name="action-btn ml-2 mt-1"
                      color="primary">
                    <v-icon small>fas fa-plus</v-icon>
                    <template #tooltip>Добавить</template>
                  </btn-with-tooltip>
                </div>
              </v-col>
              <template v-for="(_, phoneIndex) in formData.phones" v-if="formData.phones.length">
                <v-col cols="12">
                  <div class="d-flex">
                    <custom-input-text
                        pattern="###-##-###-##-##"
                        label="Доп. номер телефона"
                        name="Доп. номер телефона"
                        rules="required|phone"
                        class="flex-grow-1 mr-2"
                        v-model="formData.phones[phoneIndex]"
                    ></custom-input-text>
                    <btn-with-tooltip
                        @click="formData.phones.splice(phoneIndex, 1)"
                        class-name="action-btn ml-2 mt-1"
                        color="error">
                      <v-icon small>fas fa-minus</v-icon>
                      <template #tooltip>Удалить номер телефона</template>
                    </btn-with-tooltip>
                  </div>
                </v-col>
              </template>
              <div class="text-right mt-3">
                <v-btn class="mr-3" color="error" @click="close">Закрыть</v-btn>
                <v-btn color="primary" type="submit">Сохранить</v-btn>
              </div>
            </v-row>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {defaultDialogWidth} from "@/utils/constants";

export default {
  name: "ChangePhoneDialog",
  props: {
    value: {
      type: Boolean
    },
    phone: {
      type: String
    },
    phones: {
      type: String
    },
    id: {}
  },
  data() {
    return {
      defaultDialogWidth,
      formData: {
        phone: null,
        phones: []
      }
    }
  },
  methods: {
    async savePhones() {
      this.$showLoading()
      try {
        const formData = {...this.formData}
        formData.phones = formData.phones.map(this.refactoringNumbers)
        if (formData.phone) formData.phone = this.refactoringNumbers(formData.phone)
        await this.$http.post('admin/credit/change-phones/' + this.id, formData)
        await this.$emit('save')
        this.close();
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      } finally {
        this.$clearLoading()
      }
    },
    close() {
      this.$emit('input', false)
    },
    refactoringNumbers(number) {
      return number.replace(new RegExp('-', 'ig'), '');
    },
  },
  created() {
    this.formData.phone = this.phone;
    this.formData.phones = this.phones ? JSON.parse(this.phones) : []
  }
}
</script>

<style scoped>

</style>